import { IconAdd, IconMinus } from '@components/icons';
import classNames from 'classnames';

import { SectionDisclosureProps } from './section-disclosure.type';

export const SECTION_DISCLOSURE_TEST_ID = 'section-disclosure';

export const SectionDisclosure = ({
  title,
  open,
  onToggleOpen,
  children,
  disabled = false,
  showTopBorder = true,
  className,
  dataTestId = SECTION_DISCLOSURE_TEST_ID,
}: SectionDisclosureProps) => {
  return (
    <div data-testid={dataTestId} className={className}>
      <button
        type='button'
        aria-expanded={open}
        disabled={disabled}
        data-testid={`${dataTestId}-button`}
        onClick={onToggleOpen}
        className={classNames(
          'group flex items-center justify-between w-full py-4 text-left',
          { 'border-t border-extra-soft': showTopBorder },
          { 'cursor-pointer': !disabled, 'cursor-not-allowed opacity-50': disabled }
        )}>
        <span className='text-primary text-headline-s'>{title}</span>
        {open ? (
          <IconMinus data-testid={`${dataTestId}-icon-minus`} className='w-6 h-6 shrink-0 text-primary' />
        ) : (
          <IconAdd data-testid={`${dataTestId}-icon-add`} className='w-6 h-6 shrink-0 text-primary' />
        )}
      </button>
      {open && children}
    </div>
  );
};
